import { Injectable } from "@angular/core";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { UiInteraction } from "./ui-interaction.model";

const ACTION_PREFIX = "[Ui Interaction]";
export const UI_INTERACTION_TYPE = {
	emit: `${ACTION_PREFIX} Emit ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class UiInteractionAction {
	emit(payload: UiInteraction): ActionWithPayload {
		return {
			type: UI_INTERACTION_TYPE.emit,
			payload,
		};
	}
}
